import { Base } from 'models'
import { type IResponseTeam } from 'entities/Teams'
import { type IResponseUser } from 'entities/Users/api/types'

export class Team extends Base {
  id: number
  name!: string
  description?: string | null
  created_at!: string
  updated_at!: string
  members!: IResponseUser[]
  is_integration_team!: boolean
  integration_team!: {
    id: number
    user_integration_id: number
    vendor_team_name: string | null
    vendor_team_id: number | null
    created_at: string | null
    updated_at: string | null
  } | null
  origin!: IResponseTeam

  constructor(item: IResponseTeam) {
    super()

    this.id = item.id
    this.syncOrigin(item)
  }

  syncOrigin = (origin: IResponseTeam) => {
    this.id = origin.id
    this.name = origin.name
    this.description = origin.description
    this.created_at = origin.created_at
    this.updated_at = origin.updated_at
    this.members = origin.members
    this.is_integration_team = origin.is_integration_team
    this.integration_team = origin.integration_team
    this.origin = origin
  }

  get isIntegrationTeam() {
    return this.origin.is_integration_team
  }

  get source() {
    return this.isIntegrationTeam ? 'HubSpot' : 'Salesmsg'
  }
}
